module.exports = __webpack_public_path__ + "img/fa4d0e6.png";